import Numbers from "./number.service";
import Settings from "./settings";
import Storage from "./storage.service";
import PlansService from "./plans.service";
import CONSTANTS from "./constants.service";

const vipBundleCommitmentById = (id) => {
    // return localization key
    if (!id) return '';
    return Numbers.isBundleProductByID(id)?"VIP_BUNDLE_COMMITMENT":"VIP_NON_BUNDLE_COMMITMENT"
}

const isIphonePreorderActivated = () =>{
    let preOrder = false;
    if (Settings && Settings.enable_iphone_preorder){
        preOrder = true;
    }
    return preOrder;
}

const isDeviceAddOnsEnabled = () => {
    let businessConfig = Storage.get("businessConfig");
    return businessConfig?.enable_devices_addon;
}

const getOrfetchSavedPlan = async () => {
    await Storage.getOrfetch("saved_plan", PlansService.fetchSavedPlans);
}

const customPlanEligibleToPhoneAddOn = (skipIfDeviceSaved = true) => {
    if (Storage.get("moi-esim-instant-activation-enabled", true) === true) {
        return false;
    }
    if (Storage.get("is_resident", true) === CONSTANTS.NON_RESIDENT){
        return false;
    }
    getOrfetchSavedPlan();
    let saved_plan = Storage.get("saved_plan");
    let commitment = saved_plan?.product?.ProductCategory === "Commitment";
    let yearly = saved_plan?.product?.CommitmentDuration === 12;
    let devicePlan = userHasDevicePlan(saved_plan);
    let result = isDeviceAddOnsEnabled() && yearly && commitment;
    return skipIfDeviceSaved? result && !devicePlan :result;
}



const allowiPhonePurchase = (flags) => {
    if (!flags) flags = Storage.get("flow_status_flags");
	let eligibileForCustomPlan = customPlanEligibleToPhoneAddOn(false);
	let vip = flags?.has_vip;
    return vip || eligibileForCustomPlan;
}

// check if user saved iphone plan
const userHasDevicePlan = (saved_plan) => {
    if (!saved_plan) saved_plan = Storage.get("saved_plan");
    let devicePlan = saved_plan?.Plans?.find(p=> !Settings.types.includes(p.Type));
    return devicePlan
}

const removeDevicePlanParams = (saved_plan) => {
    if (!saved_plan) saved_plan = Storage.get("saved_plan");
    let devicePlan =  userHasDevicePlan();
    let devicePlanID;
    if (devicePlan){
        devicePlanID = devicePlan.ID;
    }
    if (devicePlanID){
            let newIDs = Object.keys(saved_plan.Plans).filter(p=>saved_plan.Plans[p].ID !== devicePlanID);
            let newPlans = newIDs.map(id=>saved_plan.Plans[id]?.['ID']);
            return {
                plan_ids: newPlans?.join(','),
                product_code: saved_plan.product?.ProductCode
            }
    }
    return false;
}

const userHasDeviceByDeliveryType = (saved_plan) => {
    if(!saved_plan){
        saved_plan = Storage.get("saved_plan");
    }
    return saved_plan?.product?.DeliveryType === "delayed";
}

const devicePrice = (saved_plan) => {
    if(!saved_plan){
        saved_plan = Storage.get("saved_plan");
    }
    let devicePlan = saved_plan?.Plans?.find(p=> !Settings.types.includes(p.Type));
    return devicePlan?.Price;
}

export {
    vipBundleCommitmentById,
    isIphonePreorderActivated,
    isDeviceAddOnsEnabled,
    customPlanEligibleToPhoneAddOn,
    allowiPhonePurchase,
    userHasDevicePlan,
    removeDevicePlanParams,
    userHasDeviceByDeliveryType,
    devicePrice
}